import { render, staticRenderFns } from "./MyIntroduce1.vue?vue&type=template&id=46fc94ca&scoped=true"
import script from "./MyIntroduce1.vue?vue&type=script&lang=js"
export * from "./MyIntroduce1.vue?vue&type=script&lang=js"
import style0 from "./MyIntroduce1.vue?vue&type=style&index=0&id=46fc94ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fc94ca",
  null
  
)

export default component.exports